

export const updateUsername = ({ me, performUpdates }) => ({ username }) => {
  return performUpdates([ me.setUsername({ username }) ])
}


export const updateEmail = ({ me, performUpdates }) => ({ email }) => {
  return performUpdates([ me.setEmail({ email }) ])
}